// ### Constants

export const API_BASE = '/api';

export const METHODS = {
  get: 'GET',
  post: 'POST',
  put: 'PUT'
};

export const URLS = {
  issue: '/issue'
};

// ### Functions

async function call(method, url, data) {
  assert(
    url.startsWith('/'),
    `API urls must start with / and are added to ${API_BASE}: "${url}"`
  );
  const full_url = API_BASE + url;

  let init = { method: method };
  if (data) {
    Object.assign(init, {
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(data)
    });
  }
  const resp = await fetch(full_url, init);

  const resp_data = await resp.json();

  return { resp, data: resp_data, status: resp.status };
}

export default call; // NOTE: seems this can't be exported inline...

export async function postIssue(data) {
  return call(METHODS.post, URLS.issue, data);
}

// ### Helpers

const assert = (cond, msg) => {
  if (!cond) {
    throw new Error(msg || `Assertion failed: ${cond}`);
  }
};
